var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.supplierCode === 'asi')?_c('asi-product-view'):(_vm.supplierCode === 'sage')?_c('sage-product-view'):_c('product-view',{key:`${_vm.supplierCode}-${_vm.productId}`,attrs:{"slug":_vm.slug,"product-id":_vm.productId,"supplier-code":_vm.supplierCode}})
}
var staticRenderFns = []

export { render, staticRenderFns }